var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotel-filters-container"},[_vm._v("#hotelfilterscontainer")])
}
var staticRenderFns = []

export { render, staticRenderFns }